// TODO most of the LD code should go in this file as its 95% the same

import { omit } from 'lodash-es';

/** omit some attributes that should never come from cache as they need to be fresh or are set immediately on every app start */
export const omitSomeCachedAttributes = (cachedUserAttributes: any) =>
  omit(cachedUserAttributes, [
    'custom.appFlowBuildId',
    'custom.appShellVersion',
    'custom.appVersion',
  ]);
